import React, { useState, useEffect } from 'react';
import { Sparkles, X } from 'lucide-react';
import { wellnessOptions, updateWellnessProfile } from '../api';

const Chip = ({ active, onClick, children }) => (
  <button onClick={onClick} className={`px-3 py-1.5 rounded-full text-xs font-jost transition-all ${active ? 'bg-gradient-to-r from-[#d4af37] to-[#f0d582] text-[#0a0708]' : 'border border-white/15 text-[#f5ecd9]/75 hover:border-[#d4af37]/40'}`}>{children}</button>
);

export const WellnessOnboarding = ({ onDone }) => {
  const [opts, setOpts] = useState(null);
  const [interests, setInterests] = useState([]);
  const [goals, setGoals] = useState([]);
  const [texture, setTexture] = useState('');
  const [saving, setSaving] = useState(false);

  useEffect(() => { wellnessOptions().then(setOpts).catch(() => {}); }, []);
  const toggle = (arr, set, v) => set(arr.includes(v) ? arr.filter((x) => x !== v) : [...arr, v]);

  const finish = async (skip) => {
    setSaving(true);
    try {
      if (skip) await updateWellnessProfile({ onboarded: true });
      else await updateWellnessProfile({ spiritual_interests: interests, goals, beauty: texture ? { hair_texture: texture } : {}, onboarded: true });
    } catch { /* ignore */ }
    setSaving(false);
    onDone && onDone();
  };

  if (!opts) return null;
  return (
    <div className="fixed inset-0 z-[70] bg-black/80 backdrop-blur-sm flex items-center justify-center p-4" data-testid="wellness-onboarding">
      <div className="relative bg-[#12100f] border border-[#d4af37]/25 rounded-2xl p-6 sm:p-8 max-w-lg w-full max-h-[90vh] overflow-y-auto">
        <button onClick={() => finish(true)} data-testid="onboarding-skip-x" className="absolute top-4 right-4 text-[#f5ecd9]/50 hover:text-[#f5ecd9]"><X className="h-5 w-5" /></button>
        <div className="text-center mb-5">
          <Sparkles className="h-9 w-9 text-[#f0d582] mx-auto mb-2" />
          <h2 className="font-cinzel text-2xl text-gold-gradient">Personalize My Prestige Experience</h2>
          <p className="font-cormorant text-lg text-[#f5ecd9]/65 mt-1">A few quick, optional picks — you can change these anytime. No spiritual quiz required.</p>
        </div>

        <p className="font-jost text-[11px] uppercase tracking-widest text-[#f5ecd9]/50 mb-2">What are you drawn to? (pick any)</p>
        <div className="flex flex-wrap gap-2 mb-5">{opts.interests.map((i) => <Chip key={i} active={interests.includes(i)} onClick={() => toggle(interests, setInterests, i)}>{i}</Chip>)}</div>

        <p className="font-jost text-[11px] uppercase tracking-widest text-[#f5ecd9]/50 mb-2">A current goal? (optional)</p>
        <div className="flex flex-wrap gap-2 mb-5">{['Meditation', 'Stress-relief / wind-down', 'Manifestation', 'Self-care', 'Hair care', 'Yoga / movement'].map((i) => <Chip key={i} active={goals.includes(i)} onClick={() => toggle(goals, setGoals, i)}>{i}</Chip>)}</div>

        <p className="font-jost text-[11px] uppercase tracking-widest text-[#f5ecd9]/50 mb-2">Hair texture? (optional)</p>
        <div className="flex flex-wrap gap-2 mb-7">{opts.beauty_options.hair_texture.map((t) => <Chip key={t} active={texture === t} onClick={() => setTexture(texture === t ? '' : t)}>{t}</Chip>)}</div>

        <div className="flex items-center justify-between gap-3">
          <button data-testid="onboarding-skip" onClick={() => finish(true)} disabled={saving} className="font-jost text-sm text-[#f5ecd9]/55 hover:text-[#f5ecd9]">Skip for now</button>
          <button data-testid="onboarding-save" onClick={() => finish(false)} disabled={saving} className="btn-gold rounded-full px-7 py-2.5 text-sm font-semibold text-[#0a0708] bg-gradient-to-r from-[#d4af37] to-[#f0d582]">Save & Personalize</button>
        </div>
      </div>
    </div>
  );
};

export default WellnessOnboarding;
